import DataGrid from '../../../../../../table/DataGrid'
import IconTooltipButton from '../../../../../../button/IconTooltipButton'
import ChipStatus from '../../Current/Elements/ChipStatus'

const List = ({ isLoading, list, permissions, onAction }) => {
  const columnsTable = [
    {
      show: true,
      key: 'primary',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Name'
    },
    {
      show: true,
      key: 'description',
      align: 'left',
      hide: false,
      width: 200,
      label: 'Description'
    },
    {
      show: permissions['preview'] || permissions['update'] || permissions['delete'],
      key: 'actions',
      align: 'center',
      hide: false,
      width: 50,
      label: 'actions'
    }
  ]

  return (
    <DataGrid
      id='special-circumstances-statusical-report'
      showSetting={false}
      rowsPerPage={list?.length || 10}
      orderByField='position'
      rows={list.map((row) => {
        return {
          ...row,
          primary: (
            <div className='flex gap-2 items-center justify-start py-2'>
              <ChipStatus status={row.name} color={row.color} bgColor={row.bgColor} border={row.border} />
            </div>
          ),
          actions: (
            <div>
              {permissions['preview'] && (
                <IconTooltipButton
                  title='Preview'
                  icon='expand-alt'
                  onClick={() => onAction('preview', row)}
                />
              )}
              {permissions['update'] && (
                <IconTooltipButton
                  title='Edit'
                  icon={['fas', 'edit']}
                  onClick={() => onAction('edit', row)}
                />
              )}
              {permissions['delete'] && (
                <IconTooltipButton
                  title='Delete'
                  icon={['fas', 'trash-alt']}
                  onClick={() => onAction('delete', row)}
                />
              )}
            </div>
          )
        }
      })}
      loading={isLoading}
      columns={columnsTable}
      labelNoRows="You don't have any status yet"
    />
  )
}

export default List
